/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import Feed from "components/Feed";

import {
  Dialog,
  DialogContent,
  AppBar,
  IconButton,
  Typography,
  Toolbar,
} from "@material-ui/core";

import "./style.css";
import { putRequest } from "utils/request";
import { postRequest } from "utils/request";

import { i18n } from '../../../translate/i18n'

export default function NewFeed({ handleGoBack, selectedFeed, companyId }) {
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [photo1, setPhoto1] = useState("");
  const [photo2, setPhoto2] = useState("");
  const [photo3, setPhoto3] = useState("");
  const [previewPhoto1, setPreviewPhoto1] = useState("");
  const [previewPhoto2, setPreviewPhoto2] = useState("");
  const [previewPhoto3, setPreviewPhoto3] = useState("");
  const [openpreview, setOpenPreview] = useState(false);
  const [selected, setSelected] = useState({
    Title: "",
    SubTitle: "",
    Description: "",
    TypeFeed: 1,
    TypeFile: 1,
    dateTimeEvent: "",
    TextLink: "",
    Link: "",
    youtube: "",
    createdAt: Date.now(),
    FeedFiles: [],
    feedFileId: [],
  });

  useEffect(() => {
    const value = JSON.stringify(selectedFeed);

    if (value !== "{}") {
      setLoading(true);

      selectedFeed.feedFileId = [];
      setSelected(selectedFeed);

      if (Number(selectedFeed.FeedFiles[0].typeFile) === 3) {
        setSelected((prevState) => {
          return { ...prevState, youtube: selectedFeed.FeedFiles[0].File };
        });
      }

      selectedFeed.FeedFiles.map((data, index) => {
        if (index === 0) {
          setPreviewPhoto1({ File: data.File, id: data.id });
        } else if (index === 1) {
          setPreviewPhoto2({ File: data.File, id: data.id });
        } else if (index === 2) {
          setPreviewPhoto3({ File: data.File, id: data.id });
        }
      });
    }
  }, [selectedFeed]);

  const handleConfirm = async (event) => {
    event.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("CompanyId", companyId);
    formData.append("title", selected.Title);
    formData.append("subTitle", selected.SubTitle);
    formData.append("description", selected.Description);
    formData.append("typeFeed", Number(selected.TypeFeed));
    formData.append("TypeFile", Number(selected.TypeFile));
    formData.append("textLink", selected.TextLink);
    formData.append("link", selected.Link);
    if (selected.dateTimeEvent) {
      formData.append("dateTimeEvent", selected.dateTimeEvent);
    }
    if (Number(selected.TypeFile) === 3) {
      formData.append("youtube", selected.youtube);
    }
    formData.append("feedfile", photo1);
    formData.append("feedfile", photo2);
    formData.append("feedfile", photo3);
    selected.feedFileId.map((data) => {
      formData.append("feedFileId", data.id);
    });
    

    const value = JSON.stringify(selectedFeed);
    if (value !== "{}") {
      putRequest(`/feeds/${selectedFeed.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (response) {
        setLoading(false);
        handleGoBack();
        }
      )
    } else {
      postRequest(`/feeds`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (response) {
            setLoading(false);
            handleGoBack();
          }
        )
    }
  };

  const handleCloseForm = () => {
    setOpenPreview(false);
  };

  const handleChangeTypeFile = () => {
    setSelected((prevState) => {
      return {
        ...prevState,
        FeedFiles: [],
      };
    });

    setSelected((prevState) => {
      return {
        ...prevState,
        youtube: "",
      };
    });

    setPreviewPhoto1("");
    setPreviewPhoto2("");
    setPreviewPhoto3("");
    setPhoto1("");
    setPhoto2("");
    setPhoto3("");
  };

  function ChangeYoutube(value) {
    let newSelected = selected;
    newSelected.FeedFiles = [];
    setSelected(newSelected);

    setSelected((prevState) => {
      return { ...prevState, youtube: value };
    });
  }

  function handleChangeFile(value) {
    let localselected = selected;
    localselected.FeedFiles.push({ File: value });
    setSelected(localselected);
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100%", 
        }}
      >
        <form onSubmit={(event) => handleConfirm(event)}>
          <div className="form-horizontal">
            <div className="form-group row mb-3">
              <label className="col-1 col-form-label">{i18n.t('title')}</label>
              <div className="col-7">
                <input
                  type="text"
                  className="form-control"
                  required
                  maxLength={100}
                  value={selected.Title}
                  onChange={(value) =>
                    setSelected((prevState) => {
                      return { ...prevState, Title: value.target.value };
                    })
                  }
                />
              </div>
            </div>
            <div className="form-group row mb-3">
              <label className="col-1 col-form-label">{i18n.t('subtitle')}</label>
              <div className="col-7">
                <input
                  type="text"
                  className="form-control"
                  value={selected.SubTitle}
                  maxLength={200}
                  onChange={(value) =>
                    setSelected((prevState) => {
                      return { ...prevState, SubTitle: value.target.value };
                    })
                  }
                />
              </div>
            </div>
            <div className="form-group row mb-3">
              <label className="col-1 col-form-label">{i18n.t('description')}</label>
              <div className="col-7">
                <input
                  type="text"
                  maxLength={2000}
                  className="form-control"
                  required
                  value={selected.Description}
                  onChange={(value) =>
                    setSelected((prevState) => {
                      return { ...prevState, Description: value.target.value };
                    })
                  }
                />
              </div>
            </div>

            <div className="form-group row mb-3">
              <label className="col-1 col-form-label">{i18n.t('type')}</label>
              <div className="col-9 row" on>
                <div className="custom-control custom-radio mr-5">
                  <input
                    type="radio"
                    id="customRadio1"
                    name="customRadio"
                    className="custom-control-input"
                    checked={Number(selected.TypeFeed) === 1 ? true : false}
                    value={1}
                    onChange={(value) =>
                      setSelected((prevState) => {
                        return { ...prevState, TypeFeed: value.target.value };
                      })
                    }
                  />
                  <label className="custom-control-label" htmlFor="customRadio1">
                    Feed
                  </label>
                </div>
                <div className="custom-control custom-radio mr-5">
                  <input
                    type="radio"
                    id="customRadio2"
                    name="customRadio"
                    className="custom-control-input"
                    checked={Number(selected.TypeFeed) === 2 ? true : false}
                    value={2}
                    onChange={(value) =>
                      setSelected((prevState) => {
                        return { ...prevState, TypeFeed: value.target.value };
                      })
                    }
                  />
                  <label className="custom-control-label" htmlFor="customRadio2">
                    {i18n.t('productsAndServices')}
                  </label>
                </div>

                <div className="custom-control custom-radio custom-control-inline mr-8">
                  <input
                    type="radio"
                    id="customRadio3"
                    name="customRadio"
                    className="custom-control-input mx-5"
                    checked={Number(selected.TypeFeed) === 3 ? true : false}
                    value={3}
                    onChange={(value) =>
                      setSelected((prevState) => {
                        return { ...prevState, TypeFeed: value.target.value };
                      })
                    }
                  />
                  <label className="custom-control-label" htmlFor="customRadio3">
                    {i18n.t('event')}
                    {Number(selected.TypeFeed) === 3 ? (
                      <>
                        <label style={{ marginLeft: 20 }}>{i18n.t('date')}:</label>
                        <input
                          className="ml-1 "
                          id="example-date"
                          type="datetime-local"
                          name="date"
                          required
                          value={selected.dateTimeEvent}
                          onChange={(value) =>
                            setSelected((prevState) => {
                              return {
                                ...prevState,
                                dateTimeEvent: value.target.value,
                              };
                            })
                          }
                        />
                        
                      </>
                    ) : (
                      <></>
                    )}
                  </label>
                </div>
              </div>
            </div>

            <div className="form-group row mb-3">
              <label className="col-1 col-form-label">{i18n.t('attachment')}</label>
              <div className="col-9 row">
                <div className="custom-control custom-radio mr-5">
                  <input
                    type="radio"
                    id="customRadio4"
                    name="customRadio2"
                    className="custom-control-input"
                    checked={Number(selected.TypeFile) === 1 ? true : false}
                    value={1}
                    onChange={(value) => {
                      setSelected((prevState) => {
                        return {
                          ...prevState,
                          TypeFile: Number(value.target.value),
                        };
                      });

                      handleChangeTypeFile();
                    }}
                  />
                  <label className="custom-control-label" htmlFor="customRadio4">
                    {i18n.t('image')}
                  </label>
                </div>
                <div className="custom-control custom-radio mr-5">
                  <input
                    type="radio"
                    id="customRadio5"
                    name="customRadio2"
                    className="custom-control-input"
                    checked={Number(selected.TypeFile) === 2 ? true : false}
                    value={2}
                    onChange={(value) => {
                      setSelected((prevState) => {
                        return {
                          ...prevState,
                          TypeFile: Number(value.target.value),
                        };
                      });
                      handleChangeTypeFile();
                    }}
                  />
                  <label className="custom-control-label" htmlFor="customRadio5">
                    Vídeo
                  </label>
                </div>

                <div className="custom-control custom-radio mr-5">
                  <input
                    type="radio"
                    id="customRadio7"
                    name="customRadio2"
                    className="custom-control-input"
                    checked={Number(selected.TypeFile) === 3 ? true : false}
                    value={3}
                    onChange={(value) => {
                      setSelected((prevState) => {
                        return {
                          ...prevState,
                          TypeFile: Number(value.target.value),
                        };
                      });

                      handleChangeTypeFile();
                    }}
                  />
                  <label className="custom-control-label" htmlFor="customRadio7">
                    Youtube
                  </label>
                </div>
              </div>
            </div>

            {Number(selected.TypeFile) === 3 ? (
              <div className="form-group row mb-3">
                <label className="col-1 col-form-label">URL Youtube</label>
                <div className="col-7">
                  <input
                    type="text"
                    className="form-control"
                    required
                    maxLength={200}
                    value={selected.youtube}
                    onChange={(value) => ChangeYoutube(value.target.value)}
                  />
                </div>
              </div>
            ) : (
              <></>
            )}

            {Number(selected.TypeFile) !== 3 ? (
              <div style={{ display: "flex", paddingLeft: 12 }}>
                <div className="form-group row mb-3 mr-3" style={{ maxWidth: 350 }}>
                  <label style={{ marginRight: 10 }}>{i18n.t('archive')} 1</label>
                  <div className="col-7">
                    {previewPhoto1?.File ? (
                      <div style={{ display: "flex" }}>
                        <img
                          src={previewPhoto1?.File}
                          className="img-company-logo-config"
                          alt="foto1"
                        />
                        <div
                          className="btn-delete-file-feed"
                          onClick={() => {
                            setPreviewPhoto1("");
                            setPhoto1("");

                            if (previewPhoto1.id) {
                              let localselected = selected;
                              localselected.feedFileId.push({
                                id: previewPhoto1.id,
                              });
                              setSelected(localselected);
                            }
                          }}
                        >
                          X
                        </div>
                      </div>
                    ) : (
                      <input
                        type="file"
                        id="example-fileinput1"
                        className="form-control-file"
                        style={{ marginRight: 20 }}
                        required
                        onChange={(file) => {
                          setPreviewPhoto1({
                            File: URL.createObjectURL(file.target.files[0]),
                          });
                          setPhoto1(file.target.files[0]);
                          handleChangeFile(
                            URL.createObjectURL(file.target.files[0])
                          );
                        }}
                      />
                    )}
                  </div>
                </div>

                {Number(selected.TypeFile) === 1 ? (
                  <>
                    <div
                      className="form-group row mb-3 mr-3"
                      style={{ maxWidth: 350 }}
                    >
                      <label style={{ marginRight: 10 }}>{i18n.t('archive')} 2</label>
                      <div className="col-7">
                        {previewPhoto2?.File ? (
                          <div style={{ display: "flex" }}>
                            <img
                              src={previewPhoto2?.File}
                              className="img-company-logo-config"
                              alt="foto2"
                            />
                            <div
                              className="btn-delete-file-feed"
                              onClick={() => {
                                setPreviewPhoto2("");
                                setPhoto2("");

                                if (previewPhoto2.id) {
                                  let localselected = selected;
                                  localselected.feedFileId.push({
                                    id: previewPhoto2.id,
                                  });
                                  setSelected(localselected);
                                }
                              }}
                            >
                              X
                            </div>
                          </div>
                        ) : (
                          <input
                            type="file"
                            id="example-fileinput2"
                            className="form-control-file"
                            style={{ marginRight: 20 }}
                            onChange={(file) => {
                              setPreviewPhoto2({
                                File: URL.createObjectURL(file.target.files[0]),
                              });
                              setPhoto2(file.target.files[0]);

                              handleChangeFile(
                                URL.createObjectURL(file.target.files[0])
                              );
                            }}
                          />
                        )}
                      </div>
                    </div>
                    <div
                      className="form-group row mb-3 mr-3"
                      style={{ maxWidth: 350 }}
                    >
                      <label style={{ marginRight: 10 }}>{i18n.t('archive')} 3</label>
                      <div className="col-7">
                        {previewPhoto3?.File ? (
                          <div style={{ display: "flex" }}>
                            <img
                              src={previewPhoto3?.File}
                              className="img-company-logo-config"
                              alt="foto3"
                            />
                            <div
                              className="btn-delete-file-feed"
                              onClick={() => {
                                setPreviewPhoto3("");
                                setPhoto3("");

                                if (previewPhoto3.id) {
                                  let localselected = selected;
                                  localselected.feedFileId.push({
                                    id: previewPhoto3.id,
                                  });
                                  setSelected(localselected);
                                }
                              }}
                            >
                              X
                            </div>
                          </div>
                        ) : (
                          <input
                            type="file"
                            id="example-fileinput3"
                            className="form-control-file"
                            style={{ marginRight: 20 }}
                            onChange={(file) => {
                              setPreviewPhoto3({
                                File: URL.createObjectURL(file.target.files[0]),
                              });
                              setPhoto3(file.target.files[0]);

                              handleChangeFile(
                                URL.createObjectURL(file.target.files[0])
                              );
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
            ) : (
              <></>
            )}

            <div className="form-group row mb-3">
              <label className="col-1 col-form-label">{i18n.t('externalSite')}</label>
              <div className="col-7">
                <input
                  type="text"
                  className="form-control"
                  value={selected.Link}
                  maxLength={200}
                  onChange={(value) =>
                    setSelected((prevState) => {
                      return { ...prevState, Link: value.target.value };
                    })
                  }
                />
              </div>
            </div>
            <div className="form-group row mb-3">
              <label className="col-1 col-form-label">{i18n.t('linkText')} </label>
              <div className="col-7">
                <input
                  type="text"
                  className="form-control"
                  value={selected.TextLink}
                  maxLength={100}
                  onChange={(value) =>
                    setSelected((prevState) => {
                      return { ...prevState, TextLink: value.target.value };
                    })
                  }
                />
              </div>
            </div>
          </div>
          <div
            className="button-list mt-3"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <button
              type="button"
              className="btn btn-outline-warning"
              onClick={() => setOpenPreview(true)}
            >
              <i i className="mdi mdi-backup-restore"></i>
              {i18n.t('preview')}
            </button>
            <button
              type="button"
              className="btn btn-outline-danger"
              onClick={() => handleGoBack()}
            >
              <i i className="mdi mdi-backup-restore"></i>
              {i18n.t('getBack')}
            </button>
            <button type="submit" className="btn btn-outline-success">
              <i className="mdi mdi-checkbox-marked-circle"></i>{i18n.t('save')}
            </button>
          </div>
        </form>
      </div>
      <Dialog
        fullScreen
        open={openpreview}
        onClose={handleCloseForm}
        style={{ zIndex: 1010 }}
      >
        <AppBar color="default" className="appbar-unify-page">
          <Toolbar>
            <Typography variant="h6" className="title-unify-page">
              {i18n.t('previewFeed')}
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseForm}
              aria-label="close"
            >
              {/* <CloseIcon /> */}X
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <div className="container-preview-feed-skute">
            <div style={{ height: "85%" }}>
              <h1>Mobile</h1>
              <div className="box-preview-feed-mobile">
                <Feed listFeed={selected} />
              </div>
            </div>
            <div style={{ height: "85%" }}>
              <h1>WEB</h1>
              <div className="box-preview-feed-web">
                <Feed listFeed={selected} />
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
